<template>

    <Head>
        <meta name="title" content="Vocabulario de Exámenes de Inglés + Cuestionario y Pronunciaciones" />
        <title>Vocabulario de Exámenes de Inglés</title>

        <meta name="description"
            content="Aquí puedes aprender las 600 palabras más importantes y sus significados de los exámenes de inglés con un cuestionario. Haz clic en el icono de sonido para escuchar la pronunciación de las palabras." />
    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">Vocabulario de Exámenes de Inglés + Cuestionario y Pronunciaciones</h1>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>

                <p>En la lista de abajo, se comparten 600 palabras en inglés junto con sus significados. Al hacer clic
                    en el
                    icono de sonido, puedes escuchar la <b>pronunciación</b> de cada palabra, y al pasar el cursor sobre
                    la
                    palabra, puedes ver un <b>ejemplo de uso de esa palabra en una oración</b>. Además, puedes trabajar
                    con
                    estas palabras mediante el <b>cuestionario</b> haciendo clic en el botón 'Ir al Cuestionario'.
                    Puedes eliminar
                    las palabras que ya conoces haciendo clic en ellas. Si inicias sesión en Diziyle Öğren, las palabras
                    que
                    ya has aprendido se eliminarán automáticamente de la lista. De esta manera, puedes concentrarte solo
                    en las
                    palabras que no conoces. Esperamos que esto te sea útil. Te deseamos éxito en tu examen 😊</p>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 20712, MeanLanguageType: 3 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    }
}

</script>